import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import type { OldDetail } from 'modules/payroll_bundle/pages/IncidenceDetailPage/_ContractInfo/helper'

import useAdditionalCompensationChanges from './useAdditionalCompensationChanges'

interface Props {
  currentContractVersionId: string | null
  oldIncidenceDetail: OldDetail
  legalEntityId?: string
}

const AdditionalCompensationDetails = ({
  currentContractVersionId,
  oldIncidenceDetail,
  legalEntityId,
}: Props) => {
  const previousContractVersionId = oldIncidenceDetail?.original_contract_version_id
    ? String(oldIncidenceDetail.original_contract_version_id)
    : null

  const { loading, changes } = useAdditionalCompensationChanges(
    currentContractVersionId,
    previousContractVersionId,
    legalEntityId
  )

  if (loading || changes.length === 0) return null

  return (
    <Box gap="s8" paddingBottom="s24">
      <Text.Normal size="200" color="grey800" weight="bold">
        {i18n.t('bookkeepers.incidence.details.sections.compensation')}
      </Text.Normal>
      <Box gap="s2" component="ul" paddingLeft="s16" style={{ listStyle: 'disc' }}>
        {changes.map((change) => (
          <IncidenceDetailDataChangeLine
            key={change.id}
            label={change.label}
            oldValue={change.oldValue}
            newValue={change.newValue}
          />
        ))}
      </Box>
    </Box>
  )
}

export default AdditionalCompensationDetails
